module.exports = __webpack_public_path__ + "img/003.fbf9a796.jpg";